import * as React from 'react';
import promotinalIcon from 'assets/chatblasts/promotional.svg';
import subscriptionIcon from 'assets/chatblasts/subscription.svg';
import notificationIcon from 'assets/chatblasts/notification.svg';

// tslint:disable
export const blasterCardTypes = {
  promoMessage: {
    name: 'Promotional Message',
    icon: promotinalIcon,
    info: (
      <div>
        Reach for free any contacts who have messaged your page in the last 24
        hours.
      </div>
    ),
    type: 'Promotional Update',
    purposeId: 10,
  },
  subscriptionMessage: {
    name: 'Subscription Message',
    icon: subscriptionIcon,
    info: (
      <div>
        A free message to your audience who has opted in to receive this type of
        update from you. Messages sent using this option must adhere to the
        <a
          href="https://developers.facebook.com/docs/messenger-platform/policy/policy-overview/#subscription_messaging"
          target="_blank"
          rel="noopener noreferrer"
        >
          {' '}
          subscription messaging guidelines{' '}
        </a>
        and your page
        <a
          href="https://customers.ai/blog/2018/07/facebook-subscription-messaging"
          target="_blank"
          rel="noopener noreferrer"
        >
          {' '}
          must be approved for Subscription Messaging.
        </a>
      </div>
    ),
    type: 'Non-Promotional Subscription',
    purposeId: 102,
  },
  notification: {
    name: 'Notification/ Update',
    icon: notificationIcon,
    info: undefined,
    type: 'Non-Promotional Subscription',
    purposeId: 0,
  },
};
// tslint:enable
